import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { Box, Hide, IconButton, Link, LogoSquare } from '@miro-site/core';
import { theme } from '@miro-site/design-tokens';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Footer = styled(Box).attrs({
  as: 'footer',
  $styles: {
    background: 'primaryWhite'
  }
}).withConfig({
  displayName: "AcquisitionFooter__Footer",
  componentId: "sc-1wanbb5-0"
})([""]);
var Wrapper = styled(Box).attrs({
  $styles: {
    maxWidth: 1680,
    position: 'relative',
    ':before': {
      content: "\"\"",
      background: 'rgba(5, 0, 56, 0.2)',
      height: '1px',
      position: 'absolute',
      top: [40, 60],
      left: [20, 40],
      right: [20, 40]
    }
  },
  $mx: 'auto',
  $pt: [81, 101],
  $pl: [20, 40],
  $pr: [20, 40],
  $pb: [20, 40]
}).withConfig({
  displayName: "AcquisitionFooter__Wrapper",
  componentId: "sc-1wanbb5-1"
})([""]);
var Container = styled(Box).attrs({
  $styles: {
    display: [undefined, 'flex'],
    alignItems: [undefined, 'center'],
    justifyContent: [undefined, 'space-between']
  }
}).withConfig({
  displayName: "AcquisitionFooter__Container",
  componentId: "sc-1wanbb5-2"
})([""]);
var Links = styled(Box).attrs({
  $styles: {
    fontSize: 18,
    lineHeight: 24
  }
}).withConfig({
  displayName: "AcquisitionFooter__Links",
  componentId: "sc-1wanbb5-3"
})([""]);
var InlineLink = styled(Link).attrs({
  $styles: {
    borderBottom: '1px solid',
    borderColor: 'rgba(5, 0, 56, 0.2)',
    transition: 'border 250ms ease',
    ':hover': {
      borderColor: 'transparent'
    },
    ':focus': _objectSpread({}, theme.focus.outlines.withOffset)
  }
}).withConfig({
  displayName: "AcquisitionFooter__InlineLink",
  componentId: "sc-1wanbb5-4"
})([""]);
var Copyright = styled(Box).attrs({
  as: 'span',
  $ml: [null, 98]
}).withConfig({
  displayName: "AcquisitionFooter__Copyright",
  componentId: "sc-1wanbb5-5"
})([""]);
var BottomWrapper = styled(Box).attrs({
  $styles: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  $mt: [40, null]
}).withConfig({
  displayName: "AcquisitionFooter__BottomWrapper",
  componentId: "sc-1wanbb5-6"
})([""]);

var AcquisitionFooter = function AcquisitionFooter() {
  return /*#__PURE__*/_jsx(ThemeProvider, {
    theme: function theme(defaultTheme) {
      return _objectSpread(_objectSpread({}, defaultTheme), {}, {
        multipliers: {
          small: function small(value) {
            return "".concat(value / 3.65, "vw");
          },
          mediumUp: function mediumUp(value) {
            return "".concat(value, "px");
          },
          mediumDown: function mediumDown(value) {
            return "".concat(value / 12, "vw");
          },
          large: function large(value) {
            return "".concat(value, "px");
          }
        }
      });
    },
    children: /*#__PURE__*/_jsx(Footer, {
      children: /*#__PURE__*/_jsxs(Wrapper, {
        children: [/*#__PURE__*/_jsx(Hide, {
          $on: ['small'],
          children: /*#__PURE__*/_jsxs(Container, {
            children: [/*#__PURE__*/_jsx(IconButton, {
              icon: /*#__PURE__*/_jsx(LogoSquare, {}),
              label: "Miro",
              href: "https://miro.com/",
              title: "Miro"
            }), /*#__PURE__*/_jsxs(Links, {
              children: [/*#__PURE__*/_jsx(InlineLink, {
                href: "/legal/terms-of-service/",
                children: "Terms"
              }), " and", ' ', /*#__PURE__*/_jsx(InlineLink, {
                href: "/legal/privacy-policy/",
                children: "Privacy Policy"
              }), /*#__PURE__*/_jsxs(Copyright, {
                children: ["\xA9 2022", ' ', /*#__PURE__*/_jsx(InlineLink, {
                  href: "https://miro.com/",
                  title: "Miro",
                  children: "Miro"
                })]
              })]
            })]
          })
        }), /*#__PURE__*/_jsx(Hide, {
          $on: ['mediumDown', 'mediumUp', 'large'],
          children: /*#__PURE__*/_jsxs(Container, {
            children: [/*#__PURE__*/_jsxs(Links, {
              children: [/*#__PURE__*/_jsx(InlineLink, {
                href: "/legal/terms-of-service/",
                children: "Terms"
              }), " and", ' ', /*#__PURE__*/_jsx(InlineLink, {
                href: "/legal/privacy-policy/",
                children: "Privacy Policy"
              })]
            }), /*#__PURE__*/_jsxs(BottomWrapper, {
              children: [/*#__PURE__*/_jsx(Links, {
                children: /*#__PURE__*/_jsxs(Copyright, {
                  children: ["\xA9 2022", ' ', /*#__PURE__*/_jsx(InlineLink, {
                    href: "https://miro.com/",
                    title: "Miro",
                    children: "Miro"
                  })]
                })
              }), /*#__PURE__*/_jsx(IconButton, {
                icon: /*#__PURE__*/_jsx(LogoSquare, {}),
                label: "Miro",
                href: "https://miro.com/",
                title: "Miro"
              })]
            })]
          })
        })]
      })
    })
  });
};

export default AcquisitionFooter;